webpackJsonp([42],{

/***/ "4NqZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tos = __webpack_require__("mK5L");

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Tos).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "L4iW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Paper.default;
  }
});

var _Paper = _interopRequireDefault(__webpack_require__("P4HR"));

/***/ }),

/***/ "P4HR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__("oMBP"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

var _warning = _interopRequireDefault(__webpack_require__("mG8X"));

var _withStyles = _interopRequireDefault(__webpack_require__("3XyW"));

var styles = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return (0, _extends2.default)({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    }
  }, elevations);
};

exports.styles = styles;

function Paper(props) {
  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      square = props.square,
      elevation = props.elevation,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "square", "elevation"]);
   false ? (0, _warning.default)(elevation >= 0 && elevation < 25, "Material-UI: this elevation `".concat(elevation, "` is not implemented.")) : void 0;
  var className = (0, _classnames.default)(classes.root, classes["elevation".concat(elevation)], (0, _defineProperty2.default)({}, classes.rounded, !square), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

Paper.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It's accepting values between 0 and 24 inclusive.
   */
  elevation: _propTypes.default.number,

  /**
   * If `true`, rounded corners are disabled.
   */
  square: _propTypes.default.bool
} : {};
Paper.defaultProps = {
  component: 'div',
  elevation: 2,
  square: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPaper'
})(Paper);

exports.default = _default;

/***/ }),

/***/ "mK5L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__("PIAa");

var _ContentWrapper = __webpack_require__("yfaX");

var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tos = function Tos() {
  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      _reactHelmet.Helmet,
      null,
      _react2.default.createElement('meta', { name: 'robots', content: 'noindex, nofollow' })
    ),
    _react2.default.createElement(
      'article',
      { role: 'article', about: '/legal/agb', 'typeof': 'schema:WebPage' },
      _react2.default.createElement(
        _ContentWrapper2.default,
        null,
        _react2.default.createElement('span', {
          property: 'schema:name',
          content: 'Allgemeine Gesch\xE4ftsbedingungen',
          className: 'stolo-hidden'
        }),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h1',
            null,
            'Allgemeine Gesch\xE4ftsbedingungen mit Kundeninformationen'
          ),
          _react2.default.createElement(
            'h2',
            null,
            'Inhaltsverzeichnis'
          ),
          _react2.default.createElement(
            'ol',
            null,
            _react2.default.createElement(
              'li',
              null,
              'Geltungsbereich'
            ),
            _react2.default.createElement(
              'li',
              null,
              'Vertragsschluss'
            ),
            _react2.default.createElement(
              'li',
              null,
              'Widerrufsrecht'
            ),
            _react2.default.createElement(
              'li',
              null,
              'Preise und Zahlungsbedingungen'
            ),
            _react2.default.createElement(
              'li',
              null,
              'Liefer- und Versandbedingungen'
            ),
            _react2.default.createElement(
              'li',
              null,
              'Einr\xE4umung von Nutzungsrechten f\xFCr digitale Inhalte'
            ),
            _react2.default.createElement(
              'li',
              null,
              'Eigentumsvorbehalt'
            ),
            _react2.default.createElement(
              'li',
              null,
              'M\xE4ngelhaftung (Gew\xE4hrleistung)'
            ),
            _react2.default.createElement(
              'li',
              null,
              'Haftung'
            ),
            _react2.default.createElement(
              'li',
              null,
              'Besondere Bedingungen f\xFCr die Verarbeitung von Waren nach bestimmten Vorgaben des Kunden'
            ),
            _react2.default.createElement(
              'li',
              null,
              'Einl\xF6sung von Aktionsgutscheinen'
            ),
            _react2.default.createElement(
              'li',
              null,
              'Einl\xF6sung von Geschenkgutscheinen'
            ),
            _react2.default.createElement(
              'li',
              null,
              'Anwendbares Recht'
            ),
            _react2.default.createElement(
              'li',
              null,
              'Gerichtsstand'
            ),
            _react2.default.createElement(
              'li',
              null,
              'Alternative Streitbeilegung'
            )
          ),
          _react2.default.createElement(
            'h2',
            null,
            '1) Geltungsbereich'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '1.1'
            ),
            '\xA0Diese Allgemeinen Gesch\xE4ftsbedingungen (nachfolgend "AGB") der Becker & Karsten UG (haftungsbeschr\xE4nkt) (nachfolgend "wir/uns"), gelten f\xFCr alle Vertr\xE4ge zur Lieferung von Waren, die du als Verbraucher oder Unternehmer (nachfolgend \u201Edu/dich\u201C) mit uns hinsichtlich der von uns in unserem Online-Shop dargestellten Waren abschlie\xDFt. Hiermit widersprechen wir der Einbeziehung deiner eigenen Bedingungen, es sei denn, wir haben etwas anderes mit dir vereinbart.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '1.2'
            ),
            '\xA0F\xFCr Vertr\xE4ge zur Lieferung von Gutscheinen gelten diese AGB entsprechend, sofern insoweit nicht etwas Abweichendes geregelt ist.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '1.3'
            ),
            '\xA0F\xFCr Vertr\xE4ge zur Bereitstellung von digitalen Inhalten gelten diese AGB entsprechend, sofern insoweit nicht etwas Abweichendes geregelt ist. Digitale Inhalte im Sinne dieser AGB sind Daten, die in digitaler Form erstellt und bereitgestellt werden.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '1.4'
            ),
            '\xA0Verbraucher im Sinne dieser AGB bist du, wenn du ein Rechtsgesch\xE4ft zu Zwecken abschlie\xDFt, die \xFCberwiegend weder deiner gewerblichen noch deiner selbst\xE4ndigen beruflichen T\xE4tigkeit zugerechnet werden k\xF6nnen.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '1.5'
            ),
            '\xA0Unternehmer im Sinne dieser AGB bist du als nat\xFCrliche oder juristische Person oder als rechtsf\xE4hige Personengesellschaft, die bei Abschluss eines Rechtsgesch\xE4fts in Aus\xFCbung deiner gewerblichen oder selbst\xE4ndigen beruflichen T\xE4tigkeit handelt.'
          ),
          _react2.default.createElement(
            'h2',
            null,
            '2) Vertragsschluss'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '2.1'
            ),
            '\xA0Die in unserem Online-Shop enthaltenen Produktbeschreibungen stellen keine verbindlichen Angebote unsererseits dar, sondern dienen zur Abgabe eines verbindlichen Angebots durch dich.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '2.2'
            ),
            '\xA0Du kannst das Angebot \xFCber das in unseren Online-Shop integrierte Online-Bestellformular abgeben. Dabei gibst du, nachdem du die ausgew\xE4hlten Waren in den virtuellen Warenkorb gelegt und den elektronischen Bestellprozess durchlaufen hast, durch Klicken des den Bestellvorgang abschlie\xDFenden Buttons ein rechtlich verbindliches Vertragsangebot in Bezug auf die im Warenkorb enthaltenen Waren ab.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '2.3'
            ),
            '\xA0Wir k\xF6nnen dein Angebot innerhalb von f\xFCnf Tagen annehmen,'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              'indem wir dir eine schriftliche Auftragsbest\xE4tigung oder eine Auftragsbest\xE4tigung in Textform (Fax oder E-Mail) \xFCbermitteln, wobei insoweit der Zugang der Auftragsbest\xE4tigung bei dir ma\xDFgeblich ist, oder'
            ),
            _react2.default.createElement(
              'li',
              null,
              'indem wir dir die bestellte Ware liefern, wobei insoweit der Zugang der Ware bei dir ma\xDFgeblich ist, oder'
            ),
            _react2.default.createElement(
              'li',
              null,
              'indem wir dich nach Abgabe deiner Bestellung zur Zahlung auffordern.'
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'Liegen mehrere der vorgenannten Alternativen vor, kommt der Vertrag in dem Zeitpunkt zustande, in dem eine der vorgenannten Alternativen zuerst eintritt. Die Frist zur Annahme deines Angebots beginnt am Tag nach der Absendung deines Angebots und endet mit dem Ablauf des f\xFCnften Tages, welcher auf die Absendung des Angebots folgt. Nehmen wir dein Angebot innerhalb vorgenannter Frist nicht an, so gilt dies als Ablehnung des Angebots mit der Folge, dass du nicht mehr an deine Willenserkl\xE4rung gebunden bist.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '2.4'
            ),
            '\xA0Bei Auswahl einer von PayPal angebotenen Zahlungsart erfolgt die Zahlungsabwicklung \xFCber den Zahlungsdienstleister PayPal (Europe) S.\xE0 r.l. et Cie, S.C.A., 22-24 Boulevard Royal, L-2449 Luxemburg (im Folgenden: \u201EPayPal\u201C), unter Geltung der PayPal-Nutzungsbedingungen, einsehbar unter ',
            _react2.default.createElement(
              'a',
              {
                href: 'https://www.paypal.com/de/legalhub/paypal/useragreement-full',
                target: '_blank' },
              'https://www.paypal.com/de/legalhub/paypal/useragreement-full'
            ),
            ' oder \u2013 falls du nicht \xFCber ein PayPal-Konto verf\xFCgst \u2013 unter Geltung der Bedingungen f\xFCr Zahlungen ohne PayPal-Konto, einsehbar unter ',
            _react2.default.createElement(
              'a',
              {
                href: 'https://www.paypal.com/de/legalhub/paypal/privacywax-full',
                target: '_blank' },
              'https://www.paypal.com/de/legalhub/paypal/privacywax-full'
            ),
            '. Zahlst du mittels einer im Online-Bestellvorgang ausw\xE4hlbaren von PayPal angebotenen Zahlungsart, erkl\xE4ren wir schon jetzt die Annahme deines Angebots in dem Zeitpunkt, in dem du den Button anklickst, welcher den Bestellvorgang abschlie\xDFt.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '2.5'
            ),
            '\xA0Bei der Bestellung \xFCber unser Online-Bestellformular speichern wir den Vertragstext nach dem Vertragsschluss und \xFCbermitteln ihn dir nach Absendung deiner Bestellung in Textform (z. B. E-Mail, Fax oder Brief). Eine dar\xFCber hinausgehende Zug\xE4nglichmachung des Vertragstextes erfolgt nicht durch uns. Sofern du vor Absendung deiner Bestellung ein Nutzerkonto in unserem Online-Shop eingerichtet hast, werden deine Bestelldaten auf unserer Website archiviert und k\xF6nnen von dir \xFCber dein passwortgesch\xFCtztes Nutzerkonto unter Angabe der entsprechenden Login-Daten kostenlos abgerufen werden.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '2.6'
            ),
            '\xA0Vor verbindlicher Abgabe der Bestellung \xFCber unser Online-Bestellformular kannst du m\xF6gliche Eingabefehler durch aufmerksames Lesen der auf dem Bildschirm dargestellten Informationen erkennen. Ein wirksames technisches Mittel zur besseren Erkennung von Eingabefehlern kann dabei die Vergr\xF6\xDFerungsfunktion deines Browsers sein, mit deren Hilfe die Darstellung auf dem Bildschirm vergr\xF6\xDFert wird. Deine Eingaben kannst du im Rahmen des elektronischen Bestellprozesses so lange \xFCber die \xFCblichen Tastatur- und Mausfunktionen korrigieren, bis du den Button anklickst, welcher den Bestellvorgang abschlie\xDFt.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '2.7'
            ),
            '\xA0F\xFCr den Vertragsschluss stehen dir unterschiedliche Sprachen zur Verf\xFCgung. Die konkrete Sprachauswahl wird im Online-Shop angezeigt.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '2.8'
            ),
            '\xA0Die Bestellabwicklung und Kontaktaufnahme finden in der Regel per E-Mail und automatisierter Bestellabwicklung statt. Du hast sicherzustellen, dass die von dir zur Bestellabwicklung angegebene E-Mail-Adresse zutreffend ist, so dass unter dieser Adresse die von uns versandten E-Mails empfangen werden k\xF6nnen. Insbesondere hast du bei dem Einsatz von SPAM-Filtern sicherzustellen, dass alle von uns oder von uns mit der Bestellabwicklung beauftragten Dritten versandten E-Mails zugestellt werden k\xF6nnen.'
          ),
          _react2.default.createElement(
            'h2',
            null,
            '3) Widerrufsrecht'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '3.1'
            ),
            '\xA0Verbrauchern steht grunds\xE4tzlich ein Widerrufsrecht zu.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '3.2'
            ),
            '\xA0N\xE4here Informationen zum Widerrufsrecht ergeben sich aus unserer Widerrufsbelehrung.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '3.3'
            ),
            '\xA0Das Widerrufsrecht gilt nicht f\xFCr Verbraucher, die zum Zeitpunkt des Vertragsschlusses keinem Mitgliedstaat der Europ\xE4ischen Union angeh\xF6ren und deren alleiniger Wohnsitz und Lieferadresse zum Zeitpunkt des Vertragsschlusses au\xDFerhalb der Europ\xE4ischen Union liegen.'
          ),
          _react2.default.createElement(
            'h2',
            null,
            '4) Preise und Zahlungsbedingungen'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '4.1'
            ),
            '\xA0Sofern sich aus unserer Produktbeschreibung nichts anderes ergibt, handelt es sich bei den angegebenen Preisen um Gesamtpreise, die die gesetzliche Umsatzsteuer enthalten. Gegebenenfalls zus\xE4tzlich anfallende Liefer- und Versandkosten werden in der jeweiligen Produktbeschreibung gesondert angegeben.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '4.2'
            ),
            '\xA0Bei Lieferungen in L\xE4nder au\xDFerhalb der Europ\xE4ischen Union k\xF6nnen im Einzelfall weitere Kosten anfallen, die wir nicht zu vertreten haben und die von dir zu tragen sind. Hierzu z\xE4hlen beispielsweise Kosten f\xFCr die Geld\xFCbermittlung durch Kreditinstitute (z.B. \xDCberweisungsgeb\xFChren, Wechselkursgeb\xFChren) oder einfuhrrechtliche Abgaben bzw. Steuern (z.B. Z\xF6lle). Solche Kosten k\xF6nnen in Bezug auf die Geld\xFCbermittlung auch dann anfallen, wenn die Lieferung nicht in ein Land au\xDFerhalb der Europ\xE4ischen Union erfolgt, du die Zahlung aber von einem Land au\xDFerhalb der Europ\xE4ischen Union aus vornimmst.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '4.3'
            ),
            '\xA0Die Zahlungsm\xF6glichkeit/en wird/werden dir in unserem Online-Shop mitgeteilt.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '4.4'
            ),
            '\xA0Ist Vorauskasse per Bank\xFCberweisung vereinbart, ist die Zahlung sofort nach Vertragsabschluss f\xE4llig, sofern wir mit dir keinen sp\xE4teren F\xE4lligkeitstermin vereinbart haben.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '4.5'
            ),
            '\xA0Bei Auswahl einer \xFCber den Zahlungsdienst "Shopify Payments" angebotenen Zahlungsart erfolgt die Zahlungsabwicklung durch den Zahlungsdienstleister Stripe Payments Europe Ltd., 1 Grand Canal Street Lower, Grand Canal Dock, Dublin, Irland (nachfolgend "Stripe"). Die einzelnen \xFCber Shopify Payments angebotenen Zahlungsarten werden dir in unserem Online-Shop mitgeteilt. Zur Abwicklung von Zahlungen kann sich Stripe weiterer Zahlungsdienste bedienen, f\xFCr die ggf. besondere Zahlungsbedingungen gelten, auf die du ggf. gesondert hingewiesen wirst. Weitere Informationen zu "Shopify Payments" sind im Internet unter ',
            _react2.default.createElement(
              'a',
              {
                href: 'https://www.shopify.com/legal/terms-payments-de',
                target: '_blank' },
              'https://www.shopify.com/legal/terms-payments-de'
            ),
            ' abrufbar.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '4.6'
            ),
            '\xA0Bei Auswahl einer \xFCber den Zahlungsdienst \u201EStripe\u201C angebotenen Zahlungsart erfolgt die Zahlungsabwicklung \xFCber den Zahlungsdienstleister Stripe Payments Europe Ltd., 1 Grand Canal Street Lower, Grand Canal Dock, Dublin, Irland (nachfolgend "Stripe"). Die einzelnen \xFCber Stripe angebotenen Zahlungsarten werden dir in unserem Online-Shop mitgeteilt. Zur Abwicklung von Zahlungen kann sich Stripe weiterer Zahlungsdienste bedienen, f\xFCr die ggf. besondere Zahlungsbedingungen gelten, auf die du ggf. gesondert hingewiesen wirst. Weitere Informationen zu Stripe sind im Internet unter ',
            _react2.default.createElement(
              'a',
              {
                href: 'https://stripe.com/de',
                target: '_blank' },
              'https://stripe.com/de'
            ),
            ' abrufbar.'
          ),
          _react2.default.createElement(
            'h2',
            null,
            '5) Liefer- und Versandbedingungen'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '5.1'
            ),
            '\xA0Bieten wir den Versand der Ware an, so erfolgt die Lieferung innerhalb des von uns angegebenen Liefergebietes an die von dir angegebene Lieferanschrift, sofern nichts anderes vereinbart ist. Bei der Abwicklung der Transaktion ist die in unserer Bestellabwicklung angegebene Lieferanschrift ma\xDFgeblich.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '5.2'
            ),
            '\xA0Scheitert die Zustellung der Ware aus Gr\xFCnden, die du zu vertreten hast, tr\xE4gst du die uns hierdurch entstehenden angemessenen Kosten. Dies gilt im Hinblick auf die Kosten f\xFCr die Hinsendung nicht, wenn du dein Widerrufsrecht wirksam aus\xFCbst. F\xFCr die R\xFCcksendekosten gilt bei wirksamer Aus\xFCbung des Widerrufsrechts durch dich die in unserer Widerrufsbelehrung hierzu getroffene Regelung.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '5.3'
            ),
            '\xA0Handelst du als Unternehmer, geht die Gefahr des zuf\xE4lligen Untergangs und der zuf\xE4lligen Verschlechterung der verkauften Ware auf dich \xFCber, sobald wir die Sache dem Spediteur, dem Frachtf\xFChrer oder der sonst zur Ausf\xFChrung der Versendung bestimmten Person oder Anstalt ausgeliefert haben. Handelst du als Verbraucher, geht die Gefahr des zuf\xE4lligen Untergangs und der zuf\xE4lligen Verschlechterung der verkauften Ware grunds\xE4tzlich erst mit \xDCbergabe der Ware an dich oder eine empfangsberechtigte Person \xFCber. Abweichend hiervon geht die Gefahr des zuf\xE4lligen Untergangs und der zuf\xE4lligen Verschlechterung der verkauften Ware auch wenn du als Verbraucher handelst bereits auf dich \xFCber, sobald wir die Sache dem Spediteur, dem Frachtf\xFChrer oder der sonst zur Ausf\xFChrung der Versendung bestimmten Person oder Anstalt ausgeliefert haben, wenn du den Spediteur, den Frachtf\xFChrer oder die sonst zur Ausf\xFChrung der Versendung bestimmte Person oder Anstalt mit der Ausf\xFChrung beauftragt hast und wir dir diese Person oder Anstalt zuvor nicht benannt haben.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '5.4'
            ),
            '\xA0Wir behalten uns das Recht vor, im Falle nicht richtiger oder nicht ordnungsgem\xE4\xDFer Selbstbelieferung vom Vertrag zur\xFCckzutreten. Dies gilt nur f\xFCr den Fall, dass die Nichtlieferung nicht von uns zu vertreten ist und wir mit der gebotenen Sorgfalt ein konkretes Deckungsgesch\xE4ft mit dem Zulieferer abgeschlossen haben. Wir werden alle zumutbaren Anstrengungen unternehmen, um die Ware zu beschaffen. Im Falle der Nichtverf\xFCgbarkeit oder der nur teilweisen Verf\xFCgbarkeit der Ware wirst du unverz\xFCglich informiert und die Gegenleistung wird dir unverz\xFCglich erstattet.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '5.5'
            ),
            '\xA0Selbstabholung ist aus logistischen Gr\xFCnden nicht m\xF6glich.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '5.6'
            ),
            '\xA0Gutscheine werden dir wie folgt bereitgestellt:'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              'per E-Mail'
            ),
            _react2.default.createElement(
              'li',
              null,
              'postalisch'
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '5.7'
            ),
            '\xA0Digitale Inhalte werden dir wie folgt bereitgestellt:'
          ),
          _react2.default.createElement(
            'p',
            null,
            '- per Download'
          ),
          _react2.default.createElement(
            'h2',
            null,
            '6) Einr\xE4umung von Nutzungsrechten f\xFCr digitale Inhalte'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '6.1'
            ),
            '\xA0Sofern sich aus der Inhaltsbeschreibung in unserem Online-Shop nichts anderes ergibt, r\xE4umen wir dir an den bereitgestellten Inhalten das nicht ausschlie\xDFliche, \xF6rtlich und zeitlich unbeschr\xE4nkte Recht ein, die Inhalte zu privaten sowie zu kommerziellen Zwecken zu nutzen.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '6.2'
            ),
            '\xA0Eine Weitergabe der Inhalte an Dritte oder die Erstellung von Kopien f\xFCr Dritte au\xDFerhalb des Rahmens dieser AGB ist nicht gestattet, soweit wir nicht einer \xDCbertragung der vertragsgegenst\xE4ndlichen Lizenz an den Dritten zugestimmt haben.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '6.3'
            ),
            '\xA0Soweit sich der Vertrag auf die einmalige Bereitstellung eines digitalen Inhalts bezieht, wird die Rechtseinr\xE4umung erst wirksam, wenn du die vertraglich geschuldete Verg\xFCtung vollst\xE4ndig geleistet hast. Wir k\xF6nnen eine Benutzung der vertragsgegenst\xE4ndlichen Inhalte auch schon vor diesem Zeitpunkt vorl\xE4ufig erlauben. Ein \xDCbergang der Rechte findet durch eine solche vorl\xE4ufige Erlaubnis nicht statt.'
          ),
          _react2.default.createElement(
            'h2',
            null,
            '7) Eigentumsvorbehalt'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Treten wir in Vorleistung, behalten wir uns bis zur vollst\xE4ndigen Bezahlung des geschuldeten Kaufpreises das Eigentum an der gelieferten Ware vor.'
          ),
          _react2.default.createElement(
            'h2',
            null,
            '8) M\xE4ngelhaftung (Gew\xE4hrleistung)'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Soweit sich aus den nachfolgenden Regelungen nichts anderes ergibt, gelten die Vorschriften der gesetzlichen M\xE4ngelhaftung. Hiervon abweichend gilt bei Vertr\xE4gen zur Lieferung von Waren:'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '8.1'
            ),
            '\xA0Handelst Du als Unternehmer,'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              'haben wir die Wahl der Art der Nacherf\xFCllung;'
            ),
            _react2.default.createElement(
              'li',
              null,
              'betr\xE4gt bei neuen Waren die Verj\xE4hrungsfrist f\xFCr M\xE4ngelrechte ein Jahr ab Ablieferung der Ware;'
            ),
            _react2.default.createElement(
              'li',
              null,
              'sind bei gebrauchten Waren die M\xE4ngelrechte ausgeschlossen;'
            ),
            _react2.default.createElement(
              'li',
              null,
              'beginnt die Verj\xE4hrung nicht erneut, wenn im Rahmen der M\xE4ngelhaftung eine Ersatzlieferung erfolgt.'
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '8.2'
            ),
            '\xA0Die vorstehend geregelten Haftungsbeschr\xE4nkungen und Fristverk\xFCrzungen gelten nicht'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              'f\xFCr Deine Schadensersatz- und Aufwendungsersatzanspr\xFCche,'
            ),
            _react2.default.createElement(
              'li',
              null,
              'f\xFCr den Fall, dass wir den Mangel arglistig verschwiegen haben,'
            ),
            _react2.default.createElement(
              'li',
              null,
              'f\xFCr Waren, die entsprechend ihrer \xFCblichen Verwendungsweise f\xFCr ein Bauwerk verwendet worden sind und dessen Mangelhaftigkeit verursacht haben,'
            ),
            _react2.default.createElement(
              'li',
              null,
              'f\xFCr eine ggf. bestehende Verpflichtung von uns zur Bereitstellung von Aktualisierungen f\xFCr digitale Produkte, bei Vertr\xE4gen zur Lieferung von Waren mit digitalen Elementen.'
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '8.3'
            ),
            '\xA0Dar\xFCber hinaus gilt f\xFCr Unternehmer, dass die gesetzlichen Verj\xE4hrungsfristen f\xFCr einen ggf. bestehenden gesetzlichen R\xFCckgriffsanspruch unber\xFChrt bleiben.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '8.4'
            ),
            '\xA0Handelst du als Kaufmann i.S.d. \xA7 1 HGB, trifft dich die kaufm\xE4nnische Untersuchungs- und R\xFCgepflicht gem\xE4\xDF \xA7 377 HGB. Unterl\xE4sst du die dort geregelten Anzeigepflichten, gilt die Ware als genehmigt.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '8.5'
            ),
            '\xA0Handelt du als Verbraucher, so wirst du gebeten, angelieferte Waren mit offensichtlichen Transportsch\xE4den bei dem Zusteller zu reklamieren und uns hiervon in Kenntnis zu setzen. Kommst du dem nicht nach, hat dies keinerlei Auswirkungen auf deine gesetzlichen oder vertraglichen M\xE4ngelanspr\xFCche.'
          ),
          _react2.default.createElement(
            'h2',
            null,
            '9) Haftung'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Der Verk\xE4ufer haftet dir aus allen vertraglichen, vertrags\xE4hnlichen und gesetzlichen, auch deliktischen Anspr\xFCchen auf Schadens- und Aufwendungsersatz wie folgt:'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '9.1'
            ),
            '\xA0Wir haften aus jedem Rechtsgrund uneingeschr\xE4nkt'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              'bei Vorsatz oder grober Fahrl\xE4ssigkeit,'
            ),
            _react2.default.createElement(
              'li',
              null,
              'bei vors\xE4tzlicher oder fahrl\xE4ssiger Verletzung des Lebens, des K\xF6rpers oder der Gesundheit,'
            ),
            _react2.default.createElement(
              'li',
              null,
              'aufgrund eines Garantieversprechens, soweit diesbez\xFCglich nichts anderes geregelt ist,'
            ),
            _react2.default.createElement(
              'li',
              null,
              'aufgrund zwingender Haftung wie etwa nach dem Produkthaftungsgesetz.'
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '9.2'
            ),
            '\xA0Wenn wir fahrl\xE4ssig eine wesentliche Vertragspflicht verletzen, ist die Haftung auf den vertragstypischen, vorhersehbaren Schaden begrenzt, sofern wir nicht gem\xE4\xDF vorstehender Ziffer unbeschr\xE4nkt haften. Wesentliche Vertragspflichten sind Pflichten, die der Vertrag uns nach seinem Inhalt zur Erreichung des Vertragszwecks auferlegt, deren Erf\xFCllung die ordnungsgem\xE4\xDFe Durchf\xFChrung des Vertrags \xFCberhaupt erst erm\xF6glicht und auf deren Einhaltung du regelm\xE4\xDFig vertrauen darfst.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '9.3'
            ),
            '\xA0Im \xDCbrigen ist eine Haftung von uns ausgeschlossen.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '9.4'
            ),
            '\xA0Vorstehende Haftungsregelungen gelten auch im Hinblick auf unsere Haftung f\xFCr unsere Erf\xFCllungsgehilfen und gesetzlichen Vertreter.'
          ),
          _react2.default.createElement(
            'h2',
            null,
            '10) Besondere Bedingungen f\xFCr die Verarbeitung von Waren nach bestimmten Vorgaben des Kunden'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '10.1'
            ),
            '\xA0Schulden wir nach dem Inhalt des Vertrages neben der Warenlieferung auch die Verarbeitung der Ware nach bestimmten Vorgaben von dir, hast du uns alle f\xFCr die Verarbeitung erforderlichen Inhalte wie Texte, Bilder oder Grafiken in den von uns vorgegebenen Dateiformaten, Formatierungen, Bild- und Dateigr\xF6\xDFen zur Verf\xFCgung zu stellen und uns die hierf\xFCr erforderlichen Nutzungsrechte einzur\xE4umen. F\xFCr die Beschaffung und den Rechteerwerb an diesen Inhalten bist allein du verantwortlich. Du erkl\xE4rst und \xFCbernimmst die Verantwortung daf\xFCr, dass du das Recht besitzt, die uns \xFCberlassenen Inhalte zu nutzen. Du tr\xE4gst insbesondere daf\xFCr Sorge, dass hierdurch keine Rechte Dritter verletzt werden, insbesondere Urheber-, Marken- und Pers\xF6nlichkeitsrechte.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '10.2'
            ),
            '\xA0Du stellst uns von Anspr\xFCchen Dritter frei, die diese im Zusammenhang mit einer Verletzung ihrer Rechte durch die vertragsgem\xE4\xDFe Nutzung der uns von dir zur Verf\xFCgung gestellten Inhalte durch uns geltend machen k\xF6nnen. Du \xFCbernimmst hierbei auch die notwendigen Kosten der Rechtsverteidigung einschlie\xDFlich aller Gerichts- und Anwaltskosten in gesetzlicher H\xF6he. Dies gilt nicht, wenn die Rechtsverletzung von dir nicht zu vertreten ist. Du bist verpflichtet, uns im Falle einer Inanspruchnahme durch Dritte unverz\xFCglich, wahrheitsgem\xE4\xDF und vollst\xE4ndig alle Informationen zur Verf\xFCgung zu stellen, die f\xFCr die Pr\xFCfung der Anspr\xFCche und eine Verteidigung erforderlich sind.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '10.3'
            ),
            '\xA0Wir behalten uns vor, Verarbeitungsauftr\xE4ge abzulehnen, wenn die von dir hierf\xFCr \xFCberlassenen Inhalte gegen gesetzliche oder beh\xF6rdliche Verbote oder gegen die guten Sitten versto\xDFen. Dies gilt insbesondere bei \xDCberlassung verfassungsfeindlicher, rassistischer, fremdenfeindlicher, diskriminierender, beleidigender, jugendgef\xE4hrdender und/oder gewaltverherrlichender Inhalte.'
          ),
          _react2.default.createElement(
            'h2',
            null,
            '11) Einl\xF6sung von Aktionsgutscheinen'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '11.1'
            ),
            '\xA0Gutscheine, die wir im Rahmen von Werbeaktionen mit einer bestimmten G\xFCltigkeitsdauer unentgeltlich ausgeben und die du nicht k\xE4uflich erwerben kannst (nachfolgend "Aktionsgutscheine"), k\xF6nnen nur in unserem Online-Shop und nur im angegebenen Zeitraum eingel\xF6st werden.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '11.2'
            ),
            '\xA0Einzelne Produkte k\xF6nnen von der Gutscheinaktion ausgeschlossen sein, sofern sich eine entsprechende Einschr\xE4nkung aus dem Inhalt deines Aktionsgutscheins ergibt.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '11.3'
            ),
            '\xA0Aktionsgutscheine k\xF6nnen nur vor Abschluss des Bestellvorgangs eingel\xF6st werden. Eine nachtr\xE4gliche Verrechnung ist nicht m\xF6glich.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '11.4'
            ),
            '\xA0Pro Bestellung kann immer nur ein Aktionsgutschein von dir eingel\xF6st werden.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '11.5'
            ),
            '\xA0Sofern sich unser Aktionsgutschein auf einen konkreten Wert und nicht auf einen prozentualen Preisnachlass bezieht, muss dein Warenwert mindestens dem Betrag des Aktionsgutscheins entsprechen. Etwaiges Restguthaben wird von uns nicht erstattet.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '11.6'
            ),
            '\xA0Reicht der Wert des Aktionsgutscheins zur Deckung deiner Bestellung nicht aus, kannst du zur Begleichung des Differenzbetrages eine der \xFCbrigen von uns angebotenen Zahlungsarten w\xE4hlen.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '11.7'
            ),
            '\xA0Das Guthaben eines Aktionsgutscheins wird weder in Bargeld ausgezahlt noch verzinst.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '11.8'
            ),
            '\xA0Der Aktionsgutschein wird nicht erstattet, wenn du die mit dem Aktionsgutschein ganz oder teilweise bezahlte Ware im Rahmen deines gesetzlichen Widerrufsrechts zur\xFCckgibst.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '11.9'
            ),
            '\xA0Der Aktionsgutschein ist \xFCbertragbar. Wir k\xF6nnen mit befreiender Wirkung an den jeweiligen Inhaber, der den Aktionsgutschein in unserem Online-Shop einl\xF6st, leisten. Dies gilt nicht, wenn wir Kenntnis oder grob fahrl\xE4ssige Unkenntnis von der Nichtberechtigung, der Gesch\xE4ftsunf\xE4higkeit oder der fehlenden Vertretungsberechtigung des jeweiligen Inhabers haben.'
          ),
          _react2.default.createElement(
            'h2',
            null,
            '12) Einl\xF6sung von Geschenkgutscheinen'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '12.1'
            ),
            '\xA0Gutscheine, die \xFCber unseren Online-Shop k\xE4uflich erworben werden k\xF6nnen (nachfolgend "Geschenkgutscheine"), k\xF6nnen nur in unserem Online-Shop eingel\xF6st werden, sofern sich aus dem Gutschein nichts anderes ergibt.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '12.2'
            ),
            '\xA0Geschenkgutscheine und Restguthaben von Geschenkgutscheinen sind bis zum Ende des dritten Jahres nach dem Jahr des Gutscheinkaufs einl\xF6sbar. Restguthaben werden dir bis zum Ablaufdatum gutgeschrieben.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '12.3'
            ),
            '\xA0Geschenkgutscheine k\xF6nnen nur vor Abschluss des Bestellvorgangs eingel\xF6st werden. Eine nachtr\xE4gliche Verrechnung ist nicht m\xF6glich.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '12.4'
            ),
            '\xA0Geschenkgutscheine k\xF6nnen nur f\xFCr den Kauf von Waren und nicht f\xFCr den Kauf von weiteren Geschenkgutscheinen verwendet werden.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '12.5'
            ),
            '\xA0Reicht der Wert des Geschenkgutscheins zur Deckung der Bestellung nicht aus, kann zur Begleichung des Differenzbetrages eine der \xFCbrigen von uns angebotenen Zahlungsarten gew\xE4hlt werden.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '12.6'
            ),
            '\xA0Das Guthaben eines Geschenkgutscheins wird weder in Bargeld ausgezahlt noch verzinst.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '12.7'
            ),
            '\xA0Der Geschenkgutschein ist \xFCbertragbar. Der Verk\xE4ufer kann mit befreiender Wirkung an den jeweiligen Inhaber, der den Geschenkgutschein im Online-Shop des Verk\xE4ufers einl\xF6st, leisten. Dies gilt nicht, wenn der Verk\xE4ufer Kenntnis oder grob fahrl\xE4ssige Unkenntnis von der Nichtberechtigung, der Gesch\xE4ftsunf\xE4higkeit oder der fehlenden Vertretungsberechtigung des jeweiligen Inhabers hat.'
          ),
          _react2.default.createElement(
            'h2',
            null,
            '13) Anwendbares Recht'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '13.1'
            ),
            '\xA0F\xFCr s\xE4mtliche Rechtsbeziehungen zwischen uns gilt das Recht der Bundesrepublik Deutschland unter Ausschluss der Gesetze \xFCber den internationalen Kauf beweglicher Waren. Wenn du als Verbraucher handelst, gilt diese Rechtswahl nur insoweit, als nicht der dir durch zwingende Bestimmungen des Rechts des Staates, in dem du deinen gew\xF6hnlichen Aufenthalt hast, gew\xE4hrte Schutz entzogen wird.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              '13.2'
            ),
            '\xA0Ferner gilt diese Rechtswahl im Hinblick auf das gesetzliche Widerrufsrecht nicht bei Verbrauchern, die zum Zeitpunkt des Vertragsschlusses keinem Mitgliedstaat der Europ\xE4ischen Union angeh\xF6ren und deren alleiniger Wohnsitz und Lieferadresse zum Zeitpunkt des Vertragsschlusses au\xDFerhalb der Europ\xE4ischen Union liegen.'
          ),
          _react2.default.createElement(
            'h2',
            null,
            '14) Gerichtsstand'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Handelst du als Kaufmann, juristische Person des \xF6ffentlichen Rechts oder \xF6ffentlich-rechtliches Sonderverm\xF6gen mit Sitz im Hoheitsgebiet der Bundesrepublik Deutschland, ist ausschlie\xDFlicher Gerichtsstand f\xFCr alle Streitigkeiten aus diesem Vertrag unser Gesch\xE4ftssitz. Hast du deinen Sitz au\xDFerhalb des Hoheitsgebiets der Bundesrepublik Deutschland, so ist unser Gesch\xE4ftssitz ausschlie\xDFlicher Gerichtsstand f\xFCr alle Streitigkeiten aus diesem Vertrag, wenn der Vertrag oder Anspr\xFCche aus dem Vertrag der beruflichen oder gewerblichen T\xE4tigkeit dir zugerechnet werden k\xF6nnen. Wir sind in den vorstehenden F\xE4llen jedoch in jedem Fall berechtigt, das Gericht an Deinem Sitz anzurufen.'
          ),
          _react2.default.createElement(
            'h2',
            null,
            '15) Alternative Streitbeilegung'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Wir sind zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle nicht verpflichtet, hierzu aber bereit.'
          )
        ),
        _react2.default.createElement(
          'div',
          { id: 'widerruf' },
          _react2.default.createElement(
            'h1',
            null,
            'Widerrufsbelehrung & Widerrufsformular'
          ),
          _react2.default.createElement(
            'h2',
            null,
            'A. Widerrufsbelehrung'
          ),
          _react2.default.createElement(
            'h3',
            null,
            'Einleitung'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Verbrauchern steht ein Widerrufsrecht nach folgender Ma\xDFgabe zu, wobei Verbraucher jede nat\xFCrliche Person ist, die ein Rechtsgesch\xE4ft zu Zwecken abschlie\xDFt, die \xFCberwiegend weder ihrer gewerblichen noch ihrer selbst\xE4ndigen beruflichen T\xE4tigkeit zugerechnet werden k\xF6nnen:'
          ),
          _react2.default.createElement(
            'h3',
            null,
            'Widerrufsrecht'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gr\xFCnden diesen Vertrag zu widerrufen.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Die Widerrufsfrist betr\xE4gt vierzehn Tage ab dem Tag, an dem Sie oder ein von Ihnen benannter Dritter, der nicht der Bef\xF6rderer ist, die letzte Ware in Besitz genommen haben bzw. hat.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Um Ihr Widerrufsrecht auszu\xFCben, m\xFCssen Sie uns (Becker & Karsten UG (haftungsbeschr\xE4nkt), Sandhauser Str. 107, 13505 Berlin, Deutschland, Tel.: +49 30 609851960, E-Mail: wir@beckerundkarsten.de) mittels einer eindeutigen Erkl\xE4rung (z. B. ein mit der Post versandter Brief oder E-Mail) \xFCber Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie k\xF6nnen daf\xFCr das beigef\xFCgte Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Sie k\xF6nnen Ihr Widerrufsrecht auch online auf der Webseite unter der Internetadresse ',
            _react2.default.createElement(
              'a',
              { href: 'https://widerruf.beckerundkarsten.de',
                target: '_blank' },
              'https://widerruf.beckerundkarsten.de'
            ),
            ' aus\xFCben. Wenn Sie diese Online-Funktion nutzen, wird Ihnen auf einem dauerhaften Datentr\xE4ger (z. B. durch eine E-Mail) unverz\xFCglich eine Eingangsbest\xE4tigung mit Informationen zum Inhalt der Widerrufserkl\xE4rung sowie dem Datum und der Uhrzeit ihres Eingangs \xFCbermittelt.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung \xFCber die Aus\xFCbung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.'
          ),
          _react2.default.createElement(
            'h3',
            null,
            'Folgen des Widerrufs'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, einschlie\xDFlich der Lieferkosten (mit Ausnahme der zus\xE4tzlichen Kosten, die sich daraus ergeben, dass Sie eine andere Art der Lieferung als die von uns angebotene, g\xFCnstigste Standardlieferung gew\xE4hlt haben), unverz\xFCglich und sp\xE4testens binnen vierzehn Tagen ab dem Tag zur\xFCckzuzahlen, an dem die Mitteilung \xFCber Ihren Widerruf dieses Vertrags bei uns eingegangen ist. F\xFCr diese R\xFCckzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der urspr\xFCnglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdr\xFCcklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser R\xFCckzahlung Entgelte berechnet. Wir k\xF6nnen die R\xFCckzahlung verweigern, bis wir die Waren wieder zur\xFCckerhalten haben oder bis Sie den Nachweis erbracht haben, dass Sie die Waren zur\xFCckgesandt haben, je nachdem, welches der fr\xFChere Zeitpunkt ist.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Sie haben die Waren unverz\xFCglich und in jedem Fall sp\xE4testens binnen vierzehn Tagen ab dem Tag, an dem Sie uns \xFCber den Widerruf dieses Vertrags unterrichten, an uns zur\xFCckzusenden oder zu \xFCbergeben. Die Frist ist gewahrt, wenn Sie die Waren vor Ablauf der Frist von vierzehn Tagen absenden.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Sie tragen die unmittelbaren Kosten der R\xFCcksendung der Waren.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Sie m\xFCssen f\xFCr einen etwaigen Wertverlust der Waren nur aufkommen, wenn dieser Wertverlust auf einen zur Pr\xFCfung der Beschaffenheit, Eigenschaften und Funktionsweise der Waren nicht notwendigen Umgang mit ihnen zur\xFCckzuf\xFChren ist.'
          ),
          _react2.default.createElement(
            'h3',
            null,
            'Ausschluss bzw. vorzeitiges Erl\xF6schen des Widerrufsrechts'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Das Widerrufsrecht besteht nicht bei Vertr\xE4gen zur Lieferung von Waren, die nicht vorgefertigt sind und f\xFCr deren Herstellung eine individuelle Auswahl oder Bestimmung durch den Verbraucher ma\xDFgeblich ist oder die eindeutig auf die pers\xF6nlichen Bed\xFCrfnisse des Verbrauchers zugeschnitten sind.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Das Widerrufsrecht gilt nicht f\xFCr Verbraucher, die zum Zeitpunkt des Vertragsschlusses keinem Mitgliedstaat der Europ\xE4ischen Union angeh\xF6ren und deren alleiniger Wohnsitz und Lieferadresse zum Zeitpunkt des Vertragsschlusses au\xDFerhalb der Europ\xE4ischen Union liegen.'
          ),
          _react2.default.createElement(
            'h2',
            null,
            'B. Widerrufsformular'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Wenn Sie den Vertrag widerrufen wollen, dann f\xFCllen Sie bitte dieses Formular aus und senden es zur\xFCck.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'An'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Becker & Karsten UG (haftungsbeschr\xE4nkt)',
            _react2.default.createElement('br', null),
            'Sandhauser Str. 107',
            _react2.default.createElement('br', null),
            '13505 Berlin',
            _react2.default.createElement('br', null),
            'Deutschland'
          ),
          _react2.default.createElement(
            'p',
            null,
            'E-Mail: wir@beckerundkarsten.de'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag \xFCber den Kauf der folgenden Waren (*) / die Erbringung der folgenden Dienstleistung (*)'
          ),
          _react2.default.createElement(
            'p',
            null,
            '_______________________________________________________'
          ),
          _react2.default.createElement(
            'p',
            null,
            '_______________________________________________________'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Bestellt am (*) ____________ / erhalten am (*) __________________'
          ),
          _react2.default.createElement(
            'p',
            null,
            '________________________________________________________',
            _react2.default.createElement('br', null),
            'Name des/der Verbraucher(s)'
          ),
          _react2.default.createElement(
            'p',
            null,
            '________________________________________________________',
            _react2.default.createElement('br', null),
            'Anschrift des/der Verbraucher(s)'
          ),
          _react2.default.createElement(
            'p',
            null,
            '________________________________________________________',
            _react2.default.createElement('br', null),
            'Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier)'
          ),
          _react2.default.createElement(
            'p',
            null,
            '_________________________',
            _react2.default.createElement('br', null),
            'Datum'
          ),
          _react2.default.createElement(
            'p',
            null,
            '(*) Unzutreffendes streichen'
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { marginTop: '3rem' } },
          _react2.default.createElement(
            'div',
            { style: {
                display: 'inline-block',
                verticalAlign: 'top'
              } },
            _react2.default.createElement(
              'a',
              {
                href: 'https://www.it-recht-kanzlei.de/', target: '_blank' },
              _react2.default.createElement('img', {
                src: 'https://www.it-recht-kanzlei.de/logo/Copyright-Logo_Widerrufsbelehrung.png?i=334dc-19c5e-39c9-907f-1',
                id: 'itkanzlei_img_copyright', alt: '\xA9 IT-Recht Kanzlei',
                title: '\xA9 IT-Recht Kanzlei',
                style: {
                  marginTop: '-20px',
                  borderStyle: 'none',
                  maxWidth: '100%'
                } })
            )
          ),
          _react2.default.createElement(
            'div',
            {
              style: {
                display: 'inline-block',
                verticalAlign: 'top',
                marginLeft: '5px',
                float: 'right',
                whiteSpace: 'nowrap'
              } },
            'Stand: 18.06.2026, 12:13:03'
          ),
          _react2.default.createElement('div', { style: { clear: 'right' } })
        )
      )
    )
  );
};

exports.default = Tos;

/***/ }),

/***/ "yfaX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Paper = __webpack_require__("L4iW");

var _Paper2 = _interopRequireDefault(_Paper);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentWrapper = (0, _styledComponents2.default)(_Paper2.default).withConfig({
  displayName: 'ContentWrapper',
  componentId: 'sc-1b74oo9-0'
})(['\n  margin: ', ' 0;\n  padding: ', ';\n  position: relative;\n    \n    & p {\n      line-height: 1.61em;\n      margin-bottom: ', ';\n      max-width: ', ';\n    }\n\n    & h1, h2, h3, h4, h5, h6 {\n      margin: ', ' 0 ', ';\n    }\n    \n    & img {\n      max-width: 100%;\n    }\n\n'], function (props) {
  return props.theme.space[12];
}, function (props) {
  return props.theme.space[10];
}, function (props) {
  return props.theme.space[9];
}, function (props) {
  return props.theme.space[23];
}, function (props) {
  return props.theme.space[7];
}, function (props) {
  return props.theme.space[12];
});

exports.default = ContentWrapper;

/***/ })

});


// WEBPACK FOOTER //
// async/deTos.7e30424fd9239919d22b.js